<template>
  <v-dialog v-model="dialogActive" width="800">
    <template v-slot:activator="{ on: dialogOn }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltipOn }">
          <v-btn v-if="smallButton" v-on="{ ...dialogOn, ...tooltipOn }" icon>
            <v-icon>{{ filtersActive ? 'fas fa-filter' : 'fal fa-filter' }}</v-icon>
          </v-btn>
          <v-btn v-else v-on="{ ...dialogOn, ...tooltipOn }" outlined>
            <v-icon left>{{ filtersActive ? 'fas fa-filter' : 'fal fa-filter' }}</v-icon>
            Filters
          </v-btn>
        </template>
        <span v-if="filtersActive">Edit current student filters</span>
        <span v-else>Set student filters</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-toolbar>
        <v-toolbar-title>Student List Filters</v-toolbar-title>
      </v-toolbar>
      <v-card-text style="padding-top:20px">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field v-model="name" label="Name Filter" clearable outlined></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-select v-model="sections" :items="sectionOptions" label="Section Filter" multiple chips small-chips deletable-chips outlined></v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-select v-model="sectionStatus" :items="sectionStatusOptions" label="Section Status" hint="Combines with Section Filter" persistent-hint multiple chips small-chips deletable-chips outlined></v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-subheader style="padding:0">Sections Completed Range</v-subheader>
            <v-text-field v-model="sectionsCompletedMin" label="Minimum" type="number" min="0" :max="sections.length" step="1" outlined clearable></v-text-field>
            <v-text-field v-model="sectionsCompletedMax" label="Maximum" type="number" min="0" :max="sections.length" step="1" outlined clearable></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-subheader style="padding:0">Slides Completed Range</v-subheader>
            <v-text-field v-model="slidesCompletedMin" label="Minimum" type="number" min="0" :max="slideCount" step="1" outlined clearable></v-text-field>
            <v-text-field v-model="slidesCompletedMax" label="Maximum" type="number" min="0" :max="slideCount" step="1" outlined clearable></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-subheader style="padding:0">Last Updated Date Range</v-subheader>
            <date-picker v-model="lastUpdateMin" :maxDate="lastUpdateMax === '' ? today : lastUpdateMax" :clear-button="true" label="Minimum Date"></date-picker>
            <date-picker v-model="lastUpdateMax" :maxDate="today" :minDate="lastUpdateMin" :clear-button="true" label="Maximum Date"></date-picker>
          </v-col>
          <v-col cols="12">
            <v-switch v-model="excludeTests" :label="(excludeTests ? 'Exclude' : 'Only Include') + ' Staff Test Accounts'"></v-switch>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="success" @click="done">Apply Filters</v-btn>
        <v-btn text @click="dialogActive = false">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn text color="error" @click="clearAll">Clear All</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { ref, computed } from '@vue/composition-api'
export default {
  components: {
    DatePicker: () => import('@/components/forms/inputs/DatePicker')
  },
  props: {
    smallButton: {
      type: Boolean,
      default: true
    }
  },
  setup (props, { root }) {
    const dialogActive = ref(false)
    const today = computed(() => {
      let dt = new Date()
      return dt.toISOString().substr(0, 10)
    })

    const sectionOptions = computed(() => {
      let sectionOptions = root.$store.state.admin.sections
      let arr = []
      for (let i = 0; i < sectionOptions.length; i++) {
        arr.push({ text: sectionOptions[i].label, value: sectionOptions[i].code })
      }
      return arr
    })
    const sectionStatusOptions = ref([
      { text: 'Completed Section', value: 'Complete' },
      { text: 'In-Progress (Started, not finished)', value: 'In-Progress' },
      { text: 'Not Started, but available to start', value: 'Ready' },
      { text: 'Locked; Cannot start yet', value: 'Locked' }
    ])
    const slideCount = computed(() => {
      let count = 0
      for (let i = 0; i < root.$store.state.admin.sections.length; i++) {
        count += root.$store.state.admin.sections[i].slides.length
      }
      return count
    })

    const name = computed({
      get: () => root.$store.state.admin.filters.name,
      set: (name) => {
        root.$store.commit('admin/updateFilter', { name })
        root.$store.dispatch('admin/loadStudents')
      }
    })
    const sections = computed({
      get: () => root.$store.state.admin.filters.sections,
      set: (sections) => {
        root.$store.commit('admin/updateFilter', { sections })
        root.$store.dispatch('admin/loadStudents')
      }
    })
    const sectionStatus = computed({
      get: () => root.$store.state.admin.filters.sectionStatus,
      set: (sectionStatus) => {
        root.$store.commit('admin/updateFilter', { sectionStatus })
        root.$store.dispatch('admin/loadStudents')
      }
    })
    const sectionsCompletedMin = computed({
      get: () => root.$store.state.admin.filters.sectionsCompleted.min,
      set: (min) => {
        root.$store.commit('admin/updateFilter', { sectionsCompleted: { min, max: sectionsCompletedMax.value } })
        root.$store.dispatch('admin/loadStudents')
      }
    })
    const sectionsCompletedMax = computed({
      get: () => root.$store.state.admin.filters.sectionsCompleted.max,
      set: (max) => {
        root.$store.commit('admin/updateFilter', { sectionsCompleted: { min: sectionsCompletedMin.value, max } })
        root.$store.dispatch('admin/loadStudents')
      }
    })
    const slidesCompletedMin = computed({
      get: () => root.$store.state.admin.filters.slidesCompleted.min,
      set: (min) => {
        root.$store.commit('admin/updateFilter', { slidesCompleted: { min, max: slidesCompletedMax.value } })
        root.$store.dispatch('admin/loadStudents')
      }
    })
    const slidesCompletedMax = computed({
      get: () => root.$store.state.admin.filters.slidesCompleted.max,
      set: (max) => {
        root.$store.commit('admin/updateFilter', { slidesCompleted: { min: slidesCompletedMin.value, max } })
        root.$store.dispatch('admin/loadStudents')
      }
    })
    const lastUpdateMin = computed({
      get: () => root.$store.state.admin.filters.lastUpdate.min,
      set: (min) => {
        root.$store.commit('admin/updateFilter', { lastUpdate: { min, max: lastUpdateMax.value } })
        root.$store.dispatch('admin/loadStudents')
      }
    })
    const lastUpdateMax = computed({
      get: () => root.$store.state.admin.filters.lastUpdate.max,
      set: (max) => {
        root.$store.commit('admin/updateFilter', { lastUpdate: { min: lastUpdateMin.value, max } })
        root.$store.dispatch('admin/loadStudents')
      }
    })
    const excludeTests = computed({
      get: () => root.$store.state.admin.filters.excludeTests,
      set: (excludeTests) => {
        root.$store.commit('admin/updateFilter', { excludeTests })
        root.$store.dispatch('admin/loadStudents')
      }
    })

    function done () {
      root.$store.dispatch('admin/loadStudents')
      dialogActive.value = false
    }

    function clearAll () {
      name.value = ''
      sections.value = []
      sectionStatus.value = []
      sectionsCompletedMin.value = null
      sectionsCompletedMax.value = null
      slidesCompletedMin.value = null
      slidesCompletedMax.value = null
      lastUpdateMin.value = null
      lastUpdateMax.value = null
      root.$store.dispatch('admin/loadStudents')
    }
    const filtersActive = computed(() => {
      return name.value !== '' ||
        sections.value.length > 0 ||
        sectionStatus.value.length > 0 ||
        sectionsCompletedMin.value != null ||
        sectionsCompletedMax.value != null ||
        slidesCompletedMin.value != null ||
        slidesCompletedMax.value != null ||
        lastUpdateMin.value != null ||
        lastUpdateMax.value != null
    })

    return {
      dialogActive,
      filtersActive,
      today,
      sectionOptions,
      sectionStatusOptions,
      slideCount,
      name,
      sections,
      sectionStatus,
      sectionsCompletedMin,
      sectionsCompletedMax,
      slidesCompletedMin,
      slidesCompletedMax,
      lastUpdateMin,
      lastUpdateMax,
      excludeTests,
      done,
      clearAll
    }
  }
}
</script>
